import {
  SeamlessLoginBase,
  SoftLoginBase,
  UpfrontLoginBase,
  RegisterBase,
  VerifyCodeBase,
} from './BaseClasses';
import LoginManager from './LoginManager/LoginManager';
import {
  LoginByEmail,
  PhoneNumberLogin,
  VerifyCode,
  Register,
  ConfirmNewPassword,
  SavedAccounts,
} from './Screens';
import LoginStatuses from './Utils/AuthStatusEnum';
import LoginTestKeys from './Utils/LoginTestKeys';

const LoginScreens = {
  PhoneLoginScreen: { screen: PhoneNumberLogin },
  LoginByEmailScreen: { screen: LoginByEmail },
  VerifyCodeScreen: { screen: VerifyCode },
  RegisterScreen: { screen: Register },
  ConfirmNewPasswordScreen: { screen: ConfirmNewPassword },
  SavedAccountsScreen: { screen: SavedAccounts },
};

export {
  LoginTestKeys,
  LoginManager,
  LoginScreens,
  LoginStatuses,
  SeamlessLoginBase,
  SoftLoginBase,
  UpfrontLoginBase,
  RegisterBase,
  VerifyCodeBase,
};
